export default "__VITE_ASSET__DYpVvG5W__"